var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceCommissionedService } from "~/services/domain-service/outsource-commissioned-manage.service";
import CommissionedDialog from "~/components/outsource-manage/commissioned-manage/commissioned-dialog.vue";
import Commissioned from "~/components/outsource-manage/commissioned-manage/commissioned.vue";
import { CityService } from "~/utils/city.service";
import { DepartmentService } from "~/services/management-service/department.service";
var CommissionedManagesIndex = /** @class */ (function (_super) {
    __extends(CommissionedManagesIndex, _super);
    function CommissionedManagesIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        _this.departmentList = []; //组织机构
        _this.caseRow = {}; //查看或编辑某一条row
        _this.queryModel = {
            outsName: "",
            outSourceType: "",
            areaId: "",
            deptId: "",
            deptName: "",
            provinceCode: "",
            outsourceStatus: ""
        };
        _this.dataList = [];
        _this.dialog = {
            commissionedDialog: false,
            commissioned: false
        };
        _this.formData = {}; //弹框列表数据
        _this.refresh = {};
        return _this;
    }
    CommissionedManagesIndex.prototype.mounted = function () {
        this.getDepartments();
        this.refreshData();
        this.getProvinces();
    };
    //获取省数据
    CommissionedManagesIndex.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    CommissionedManagesIndex.prototype.getCitys = function (provinceId) {
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    //获取组织机构
    CommissionedManagesIndex.prototype.getDepartments = function () {
        var _this = this;
        this.departmentService.querySubDepartment().subscribe(function (data) {
            _this.departmentList = data;
        });
    };
    CommissionedManagesIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceCommissionedService
            .searchCutsourceList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataList = data;
        });
    };
    /**
     * 修改
     */
    CommissionedManagesIndex.prototype.editDetail = function (scope) {
        this.dialog.commissionedDialog = true;
        this.caseRow = {
            name: scope.row.outsName,
            organizationType: scope.row.outSourceType,
            status: scope.row.outsourceStatus,
            companyCode: scope.row.companyCode,
            deptName: scope.row.deptName,
            proinviceCode: scope.row.areaId,
            cityCode: scope.row.areaId,
            address: scope.row.outsAddress,
            linkMan: scope.row.outsContacts,
            linkPhone: scope.row.outsPhone,
            remark: scope.row.outsRemark,
            email: scope.row.email,
            areaId: scope.row.areaId,
            areaCodeIds: scope.row.areaCodeIds,
            id: scope.row.id
        };
    };
    /**
     * 查看
     */
    CommissionedManagesIndex.prototype.checkDetail = function (scope) {
        this.dialog.commissioned = true;
        this.caseRow = scope.row;
    };
    /**
     * 重置numberRange
     */
    CommissionedManagesIndex.prototype.follFeedback = function () {
        this.queryModel.proinviceCode = "";
        this.queryModel.areaCodeIds = "";
    };
    __decorate([
        Dependencies(OutsourceCommissionedService)
    ], CommissionedManagesIndex.prototype, "outsourceCommissionedService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CommissionedManagesIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CommissionedManagesIndex.prototype, "sortService", void 0);
    __decorate([
        Dependencies(DepartmentService)
    ], CommissionedManagesIndex.prototype, "departmentService", void 0);
    CommissionedManagesIndex = __decorate([
        Auth(1001),
        Layout("workspace"),
        Component({
            components: {
                CommissionedDialog: CommissionedDialog,
                Commissioned: Commissioned
            }
        })
    ], CommissionedManagesIndex);
    return CommissionedManagesIndex;
}(Vue));
export default CommissionedManagesIndex;
